count_one: '{{ count }} yacht'
count_other: '{{ count }} yachts'
yachtSearch: Yacht Search
details: Yacht Details
listing:
  title: Managed Yacht Listings
rateVerified:
  managed: Rate Verified
  today: Rate Verified Today
  recently: Rate Verified
lastSeen: 'Last seen: {{ placeName }}'
priceConverted: Converted & rounded from {{ value }}
noUsaDutyWarning: Not for charter to U.S. residents while in U.S. waters.
noEuDutyWarning: Not for charter to EU residents while in EU waters.
flagCountry: 'Flag country: {{ country }}'
specialValidUntil: Valid until {{ date }}
brochureLinks:
  branded: Branded Brochure
  friendly: Friendly Brochure
label:
  lengthMeters: Length
  beamMeters: Beam
  draftMeters: Draft
  yearLaunch: Launched
  yearRefit: Refit
  builder: Builder
  designer: Designer
  construction: Material
  engine: Engines
  speedCruiseKPH: Speed (Cruising)
  speedMaxKPH: Speed (Max)
  rangeCruiseKm: Range (Cruising)
  rangeMaxKm: Range (Max)
  fuelCruiseLPH: Fuel (Cruising)
  fuelMaxLPH: Fuel (Max)
  flagCountry: Flag
  guestsSleeping: Guests (Sleeping)
  guestsCruising: Guests (Cruising)
  guestsEntertaining: Guests (Entertaining)
  masterCabinLocation: Primary Cabin Location
  crewCabinLocation: Crew Cabin Location
  smoking: Smoking
  voltage: Voltage
  guests_one: 'guest'
  guests_other: 'guests'
  cabins_one: 'cabin'
  cabins_other: 'cabins'
  crew: 'crew'
apaPercent: '{{ apa }}% APA'
taxPercent: '{{ tax }}% Tax'
dubiousRatesWarning: |
  The rates provided by {{ centralAgentName }} have destinations that seem to
  conflict over the same date ranges.<br/>Please <0>contact {{ centralAgentName }}</0> to
  confirm.
inquireForRate: Inquire for Rate
moreImages: + {{ count }} more images
guests_one: 1 guest
guests_other: "{{ count }} guests"
cabins_one: 1 cabin
cabins_other: "{{ count }} cabins"
